import { formatInTimeZone } from "date-fns-tz/formatInTimeZone";
import { getIanaFromRailsZone } from "~/utils/time-zones";
import User from "~/types/UserType";
import Org from "~/types/OrgType";

function getUTCDate(date: Date) {
  // Store UTC Values
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const hour = date.getUTCHours();
  const minute = date.getUTCMinutes();

  // Return UTC Date
  return Date.UTC(year, month, day, hour, minute);
}

function getFormat() {
  const user: User = JSON.parse(localStorage.getItem("user") ?? "{}");
  let format = "MM/dd/yyyy";

  if (user && user.preferences?.date_format) {
    const formatMapping = {
      "MM/DD/YYYY": "MM/dd/yyyy",
      "DD/MM/YYYY": "dd/MM/yyyy",
      "MM-DD-YYYY": "MM-dd-yyyy",
      "DD-MM-YYYY": "dd-MM-yyyy",
      "MM.DD.YYYY": "MM.dd.yyyy",
      "DD.MM.YYYY": "dd.MM.yyyy",
    };

    if (formatMapping[user.preferences?.date_format]) {
      format = formatMapping[user.preferences.date_format];
    }
  }
  return format;
}

function getTimezone() {
  const org: Org = JSON.parse(localStorage.getItem("organization") || "{}");
  let timeZone = "Etc/UTC";

  if (org && org?.attributes?.time_zone) {
    const ianaTZ = getIanaFromRailsZone(org.attributes.time_zone);

    if (ianaTZ) {
      timeZone = ianaTZ;
    }
  }

  return timeZone;
}

export function normalizeUTCDateString(dateString: string) {
  return dateString.includes("+") || dateString.includes("-")
    ? dateString
    : `${dateString}+00:00`;
}

export function formatUtcDateWithTimezone(
  dateString: string,
  timezone: string,
  format: string,
) {
  // Normalize UTC Date String
  const utcDateString = normalizeUTCDateString(dateString);

  // Create Date Obj with User's Local Timezone
  const date = new Date(utcDateString);

  // Create UTC Date
  const utcDate = getUTCDate(date);

  return formatInTimeZone(utcDate, timezone, format);
}

export function formatDate(date: Date) {
  const utcDate = getUTCDate(date);

  return formatInTimeZone(utcDate, getTimezone(), getFormat());
}

export function convertTo12HourFormat(timestamp: string) {
  // eslint-disable-next-line prefer-const
  let [hours, minutes] = timestamp.split(":").map(Number);

  // Convert '0' hour to '12' for midnight and handle hours over 12
  hours = hours % 12 || 12;

  // Format minutes to ensure it has leading zeros
  const formattedMinutes = minutes.toString().padStart(2, "0");

  // Return the formatted time string in 12-hour format with AM/PM
  return `${hours}:${formattedMinutes}`;
}

export function timestampToDate(timestamp: string): number {
  // Parse the timestamp (YYYYMMDDHHmmss format) into components
  return new Date(timestamp).getTime();
}
